import FlexImages from 'javascript-flex-images';
import initPhotoSwipeFromDOM from './components/initPhotoSwipeFromDom';

(function () {
  initPhotoSwipeFromDOM('.gallery');

  new FlexImages({ selector: '.gallery', rowHeight: 280, container: 'figure' });
})();
